import { CanActivateFn, Router } from '@angular/router';
import { computed, inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { AuthStatus } from '../interfaces';

export const isAuthenticatedGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const currentUrl = state.url;

  const authStatus = computed(() => authService.authStatus());
  const token = localStorage.getItem('token');

  if (token || authStatus() === AuthStatus.authenticated) {
    localStorage.setItem('url', currentUrl);
    return true;
  } else {
    router.navigateByUrl('/auth/login');
    return false;
  }

}

// const checkAuthentication = () => {
//   switch (authService.authStatus()) {
//     case AuthStatus.authenticated:
//       localStorage.setItem('url', state.url);
//       return true;
//     case AuthStatus.notAuthenticated:
//       localStorage.setItem('url', state.url);
//       router.navigateByUrl('/auth/login');
//       return false;
//     default:
//       console.log('default')
//       console.log(currentUrl)
//       // router.navigateByUrl('/');
//       return true;
//   }
// };

// // Verificar el estado de autenticación actual
// const isAuthenticated = checkAuthentication();

// console.log(isAuthenticated)
// const url = state.url;
// if(!isAuthenticated){
//   const urlStatu = router.createUrlTree(['/auth/login']);
//   router.navigateByUrl(urlStatu);
// }


// // Retornar el estado de autenticación actual
// return isAuthenticated;


// if (authService.authStatus() === AuthStatus.checking) {
//   return false;
// }
// const url = state.url;
// localStorage.setItem('url', url);
// router.navigateByUrl('/auth/login');
